export default "__VITE_ASSET__R9o9Pf88__"